import styled, { css } from 'styled-components';
import { getTextColor, themeGet } from '@magalu/stereo-ui-styles';
import Box from '../../atoms/Box';
import RspImage from '../../atoms/ResponsiveImage';
export const Container = styled.li`
  display: flex;
  align-items: center;
  padding: ${props => themeGet(`space.${props.desktopMode ? 1 : 2}`)(props)}px;
  ${props => props.desktopMode && css`
      cursor: pointer;
      ${({
  borderBottom
}) => borderBottom && css`
          border-bottom: 1px solid #e5e5e5;
        `}

      :hover {
        background-color: #dcebf4;
      }
    `}
`;
export const ContainerText = styled(Box)`
  padding-left: ${props => themeGet('space.1')(props)}px;
  font-size: ${props => themeGet(`fontSizes.${props.desktopMode ? 0 : 2}`)(props)}px;
  color: ${props => getTextColor('scratched')(props)};
`;
export const ContainerTextPrice = styled(Box)`
  padding-left: ${props => themeGet('space.1')(props)}px;
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  color: ${props => getTextColor('primary')(props)};
  font-weight: ${props => themeGet('fontWeights.bold')(props)};
  text-align: initial;
`;
export const ProductImage = styled(RspImage)``;
export const ProductImageContainer = styled.div`
  width: 59px;
  height: 44px;
`;